import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { media, layout } from '@prisjakt/ui-base';

const ellipsisWrapperMinWidth = 0;
const sharedStyleBreadcrumbs = css`
  display: flex;
  font-size: ${layout.measurements.fontSizeSmall};
  color: ${p => p.theme.text.tertiary};
  line-height: 1.2;
  min-width: ${ellipsisWrapperMinWidth};
`;

type InnerProps = {
  mobile?: boolean;
  desktop?: boolean;
};

export const Breadcrumbs = styled.div<InnerProps>(
  ({ mobile, desktop }) => css`
    display: none;
    margin: ${layout.measurements.spacingTiny};
    align-items: center;
    ${media.smallOnly`
      display: ${mobile ? 'flex' : 'none'};
    `}
    ${media.mediumUp`
       display: ${desktop ? 'flex' : 'none'};
       font-size: ${layout.measurements.fontSizeNormal};
    `}
  `
);

export const Crumb = styled(Link).attrs({ 'data-test': 'Crumb' })`
  align-items: center;
  font-weight: 400;
  ${sharedStyleBreadcrumbs};
`;

export const Current = styled.span.attrs({
  'data-test': 'Crumb',
  'data-test-type': 'current',
})`
  font-weight: 600;
  ${sharedStyleBreadcrumbs};
`;

export const Ellipsis = styled.span`
  display: inline;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const ArrowStyles = css<InnerProps>(
  ({ mobile, theme }) => css`
    display: flex;
    font-size: ${layout.measurements.fontSizeNormal};
    width: ${layout.measurements.spacingMedium} !important;
    height: ${layout.measurements.spacingMedium} !important;
    margin-right: ${layout.measurements.spacingTiny};
    margin-left: ${mobile ? 0 : layout.measurements.spacingTiny};
    path {
      fill: ${theme.text.quaternary};
    }
  `
);
